// @ts-nocheck
import { createSlice } from "@reduxjs/toolkit";
import {
  ERROR_TYPES,
  FULLFILLED,
  PENDING,
  REJECTED,
  ROLES,
} from "@root/constants";
import { SEND_INPUT } from "@root/store/action-types";
import {
  DO_QUERY_ACTION,
  GET_GOVT_RULES_API_ACTION,
  GET_IMAGES_DESC_API_ACTION,
  RISKCHECK_API_ACTION,
} from "@root/store/action-types/chatActions";
import {
  getSystemTypeChatItem,
  removeDuplicates,
  RISKCHECKER_CHAT_STATUS,
} from "@root/utils/chatHelper";
import { USER_ROLES, WEB_PROJECTS } from "@root/webConstants";

const initialValue = {
  input: "",
  threadList: [],
  threadId: null,
  loading: false,
  riskCheckerFileUploading: false,
  isEditing: false,
  editState: {
    index: 1,
  },
  doazGptFileUploading: false,
  pid: null,
  riskCheckerInput: "",
  riskcheckerSelectedFiles: [],
  riskcheckerSelectedFilesURLs: [],
  doazGptSelectedFiles: [],
  doazGptSelectedFilesURLs: [],
  conGptSelectedDocs: [],
  riskcheckerSelectedField: { id: 1 },
  imagePopupState: {
    url: null,
  },
  threadPage: 1,
  chatFeedback: {
    open: false,
    tags: [],
    input: "Not provided.",
    metaData: {},
    isLike: null,
  },
  chatId: null,
  chat_history: [],
  selectedModel: JSON.parse(process.env.REACT_APP_CHAT_MODELES ?? "[]")?.[0], // Model selected when user starts chat initially
};

export const threadSlice = createSlice({
  name: "thread",
  initialState: initialValue,
  reducers: {
    updateUserInput: (state, action: any) => {
      state.input = action.payload;
    },
    updateChatPID: (state, { payload }: any) => {
      state.pid = payload;
    },
    updateRiskCheckerInput: (state, { payload }: any) => {
      state.riskCheckerInput = payload;
    },
    updateRiskCheckerSelectedFiles: (state, { payload }: any) => {
      state.riskcheckerSelectedFiles = payload;
    },
    updateRiskCheckerSelectedFilesURLs: (state, { payload }: any) => {
      state.riskcheckerSelectedFilesURLs = payload;
    },
    updateDoazGptSelectedFiles: (state, { payload }: any) => {
      state.doazGptSelectedFiles = payload;
    },
    updateDoazGptSelectedFilesURLs: (state, { payload }: any) => {
      state.doazGptSelectedFilesURLs = payload;
    },
    updateRiskCheckerSelectedField: (state, { payload }: any) => {
      state.riskcheckerSelectedField = payload;
    },
    updateConGptSelectedDocs: (state, { payload }: any) => {
      state.conGptSelectedDocs = payload;
    },
    updateThreadList: (state, { payload }: any) => {
      state.threadList = payload;
      state.threadPage = 1;
    },
    mergeInThreadList: (state, { payload }: any) => {
      state.threadList = [...payload, ...state.threadList];
      state.threadPage = state.threadPage + 1;
    },
    updateImagePopup: (state, { payload }: any) => {
      state.imagePopupState = payload;
    },
    updateThreadPage: (state, { payload }: any) => {
      state.threadPage = payload;
    },
    updateThreadLoading: (state, { payload }: any) => {
      state.loading = payload;
      if (payload === false) {
        state.riskcheckerSelectedFilesURLs = [];
        state.riskcheckerSelectedFiles = [];
      }
    },
    updateRiskcheckerFileUploading: (state, { payload }: any) => {
      state.riskCheckerFileUploading = payload;
    },
    updateDoazGptFileUploading: (state, { payload }: any) => {
      state.doazGptFileUploading = payload;
    },
    updateCurrentThreadId: (state, { payload }: any) => {
      state.threadId = payload;
    },
    updateCurrentThreadChatId: (state, { payload }: any) => {
      state.chatId = payload;
    },
    updateThreadHistory: (state, { payload }: any) => {
      state.chat_history = payload;
    },
    updateThreadChatById: (state, action: any) => {
      const { payload, id, merge, userPayload } = action.payload;
      if (id) {
        const data = state.threadList.map((thread) => {
          if (thread?.id === id && thread?.role === ROLES.ASSISTANT) {
            if (merge) {
              return { ...thread, ...payload };
            } else {
              return payload;
            }
          } else if (thread?.id === id && thread?.role === ROLES.USER) {
            if (merge) {
              return { ...thread, ...userPayload };
            } else {
              return payload;
            }
          } else {
            return thread;
          }
        });
        state.threadList = data;
      }
    },
    updateSelectedModel: (state, action: any) => {
      state.selectedModel = action.payload;
    },
    updateChatFeedbackState: (state, { payload }: any) => {
      state.chatFeedback = payload;
    },
    addInThreadList: (state, { payload }: any) => {
      state.threadList = [...state.threadList, ...payload];
    },
  },
  extraReducers: (builder) => {
    // HANDLE RISK CHECKER OPTION 1
    // FOR WITHOUT IMAGE CASE
    builder.addCase(
      `${RISKCHECK_API_ACTION}${PENDING}`,
      (state, { meta }: any) => {
        const { payload, proceedStore, id, filesUrls, images_desc } = meta?.arg;
        if (
          (payload?.identifier === 1 || payload?.identifier === 3) &&
          proceedStore &&
          id
        ) {
          state.loading = true;
          const tempChatItem = {
            id,
            input: payload?.input || "",
            selectedFiles: filesUrls,
            pid: WEB_PROJECTS.RISK_CHECKER.id,
            PID: WEB_PROJECTS.RISK_CHECKER.id,
            role: USER_ROLES.USER,
            selectOption: payload?.identifier,
            proceedStore,
            images_desc,
          };
          state.threadList = [...state.threadList, tempChatItem];
        }
        if (images_desc && !proceedStore) {
          const thread_count = state.threadList.length;
          let prev_chat = state.threadList[thread_count - 1];
          prev_chat.images_desc = images_desc;
          const updatedThreadList = state.threadList.slice(0, -1);
          state.threadList = [...updatedThreadList, prev_chat];
        }
      }
    );
    builder.addCase(
      `${RISKCHECK_API_ACTION}${FULLFILLED}`,
      (state, { payload }: any) => {
        // state.chat_history = payload?.data?.chat_history
        state.threadId = payload?.data?.threadId;
        const thread_count = state.threadList.length;
        const prev_chat = state.threadList[thread_count - 1];
        if (prev_chat?.proceedStore) {
          const [userChat, systemChat] = getSystemTypeChatItem(
            payload?.data,
            prev_chat
          );
          const updatedThreadList = state.threadList.slice(0, -1);
          if (prev_chat?.images_desc?.image_description) {
            systemChat.image_description_res = prev_chat?.images_desc;
            systemChat.images_description_status =
              RISKCHECKER_CHAT_STATUS.SUCCESS;
          }
          state.threadList = [...updatedThreadList, userChat, systemChat];
          state.loading = false;
        }
      }
    );
    builder.addCase(
      `${RISKCHECK_API_ACTION}${REJECTED}`,
      (state, { payload }: any) => {
        state.loading = false;
      }
    );
    // FOR IMAGE CASE IN OPTION 1 AND OPTION 2
    builder.addCase(
      `${GET_IMAGES_DESC_API_ACTION}${PENDING}`,
      (state, { meta }: any) => {
        const { payload, proceedStore, id, input, identifier } = meta?.arg;
        if (proceedStore && id) {
          state.loading = true;
          const tempChatItem = {
            id,
            input: input || "",
            selectedFiles: payload?.image_urls,
            pid: WEB_PROJECTS.RISK_CHECKER.id,
            PID: WEB_PROJECTS.RISK_CHECKER.id,
            role: USER_ROLES.USER,
            selectOption: identifier,
            proceedStore,
          };
          state.threadList = [...state.threadList, tempChatItem];
          state.riskcheckerSelectedFiles = [];
          state.riskcheckerSelectedFilesURLs = [];
        }
      }
    );
    // END
    // HANDLE RISKCHECKER OPTION 2
    builder.addCase(
      `${GET_GOVT_RULES_API_ACTION}${PENDING}`,
      (state, { meta }: any) => {
        const { payload, proceedStore, id, filesUrls, images_desc } = meta?.arg;
        if (payload?.identifier === 2 && proceedStore && id) {
          state.loading = true;
          const tempChatItem = {
            id,
            input: payload?.input || "",
            selectedFiles: filesUrls,
            pid: WEB_PROJECTS.RISK_CHECKER.id,
            PID: WEB_PROJECTS.RISK_CHECKER.id,
            role: USER_ROLES.USER,
            selectOption: payload?.identifier,
            proceedStore,
            images_desc,
          };
          state.threadList = [...state.threadList, tempChatItem];
        }
        if (images_desc && !proceedStore) {
          const thread_count = state.threadList.length;
          let prev_chat = state.threadList[thread_count - 1];
          prev_chat.images_desc = images_desc;
          const updatedThreadList = state.threadList.slice(0, -1);
          state.threadList = [...updatedThreadList, prev_chat];
        }
      }
    );
    builder.addCase(
      `${GET_GOVT_RULES_API_ACTION}${FULLFILLED}`,
      (state, { payload }: any) => {
        const thread_count = state.threadList.length;
        const prev_chat = state.threadList[thread_count - 1];
        if (prev_chat?.proceedStore) {
          const [userChat, systemChat] = getSystemTypeChatItem(
            payload?.data,
            prev_chat
          );
          const updatedThreadList = state.threadList.slice(0, -1);
          if (prev_chat?.images_desc?.image_description) {
            systemChat.image_description_res = prev_chat?.images_desc;
            systemChat.images_description_status =
              RISKCHECKER_CHAT_STATUS.SUCCESS;
          }
          systemChat.government_rules = payload?.data;
          systemChat.govt_rules_status = RISKCHECKER_CHAT_STATUS.SUCCESS;
          state.threadList = [...updatedThreadList, userChat, systemChat];
          state.loading = false;
        }
        state.threadId = payload?.data?.threadId;
        // state.chat_history = payload?.data?.chat_history
      }
    );
    builder.addCase(`${DO_QUERY_ACTION}${PENDING}`, (state, { meta }: any) => {
      state.loading = true;
      const { payload, id } = meta?.arg;
      if (payload && id) {
        let userChatItem = {
          id,
          input: payload?.query || payload?.url || "",
          role: ROLES.USER,
        };
        if (state.threadId) {
          state.threadList = [...state.threadList, userChatItem];
        } else {
          state.threadList = [userChatItem];
        }
      }
    });
    builder.addCase(
      `${DO_QUERY_ACTION}${FULLFILLED}`,
      (state, { payload }: any) => {
        const { data }: any = payload;
        if (data) {
          if (!state?.threadId) {
            state.threadId = data?.threadId;
          }
          const thread_count = state.threadList.length;
          const prev_chat = state.threadList[thread_count - 1];
          const chat = getSystemTypeChatItem(data, prev_chat);
          const updatedThreadList = state.threadList.slice(0, -1);
          state.threadList = removeDuplicates([...updatedThreadList, ...chat]);
          state.loading = false;
        }
      }
    );
    builder.addCase(
      `${DO_QUERY_ACTION}${REJECTED}`,
      (state, { payload, meta: { arg } }: any) => {
        state.loading = false;
        const { response } = payload;
        let errorChat = {};

        switch (response?.status) {
          case 429:
            errorChat = {
              role: ROLES.ASSISTANT,
              error: {
                type: ERROR_TYPES.CUSTOM,
                message: response?.data?.error || "",
              },
            };

            break;

          default:
            errorChat = {
              role: ROLES.ASSISTANT,
              error: {
                type: ERROR_TYPES.DEFAULT,
              },
            };
            break;
        }
        state.threadList = [...state.threadList, errorChat];
      }
    );
    builder.addCase(
      `${SEND_INPUT}${PENDING}`,
      (state, { payload, meta: { arg } }: any) => {
        state.isEditing = true;
      }
    );
    builder.addCase(
      `${SEND_INPUT}${FULLFILLED}`,
      (state, { payload, meta: { arg } }: any) => {
        state.isEditing = false;
      }
    );
    builder.addCase(
      `${SEND_INPUT}${REJECTED}`,
      (state, { payload, meta: { arg } }: any) => {
        state.isEditing = false;
      }
    );
  },
});

export const {
  updateUserInput,
  updateChatPID,
  updateThreadChatById,
  updateRiskCheckerInput,
  updateRiskCheckerSelectedFiles,
  updateRiskCheckerSelectedFilesURLs,
  updateRiskCheckerSelectedField,
  updateThreadList,
  updateThreadLoading,
  updateRiskcheckerFileUploading,
  updateImagePopup,
  updateCurrentThreadId,
  mergeInThreadList,
  updateThreadPage,
  updateDoazGptFileUploading,
  updateDoazGptSelectedFiles,
  updateDoazGptSelectedFilesURLs,
  updateChatFeedbackState,
  addInThreadList,
  updateCurrentThreadChatId,
  updateThreadHistory,
  updateConGptSelectedDocs,
  updateSelectedModel,
} = threadSlice.actions;
export const activeThreadReducer = threadSlice.reducer;
